import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import { getadministrationList, getGroup } from '../../api/api'
import Grouptable from './components/groupTable/groupTable'
// import NewMember from './components/newMember/newMember'
import './index.css'
import moment from 'moment'
import NewGroup from './components/newGroup/newGroup'

const { RangePicker } = DatePicker
const FallGroup = () => {
  const [componentSize, setComponentSize] = useState('default')
  const [payload, setPayload] = useState({ page: '1', pagesize: '10' })
  const [total, setTotal] = useState(0)
  const [form] = useForm()
  const memberRef = useRef()
  const [isFresh, setIsFresh] = useState(false)

  useEffect(() => {
    getGroup({ params: payload }).then((res) => {
      console.log(res.data.data)
      const info = res.data.data
      if (info.total === 0) {
        message.error('未能找到指定条件内容！')
      }
      memberRef.current.changeData(res.data.data.rows)
      setTotal(res.data.data.total)
    })
  }, [payload, isFresh])

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size)
  }

  const handleSubmit = (values) => {
    console.log('“value', values)
    let payload = {
      page: '1',
      pagesize: '10',
      name: values.name,
      is_visible: values.is_visible,
    }
    let start = values?.date[0]
    let end = values?.date[1]

    if (start !== '') {
      payload['period_start'] = moment(start).format('YYYY-MM-DD')
    }
    if (end !== '') {
      payload['period_end'] = moment(end).format('YYYY-MM-DD')
    }
    setPayload(payload)
  }

  const resetSelectors = () => {
    form.resetFields()
  }
  const pageChange = (e) => {
    //分页改变的回调
    setPayload({
      ...payload,
      page: e,
    })
  }
  return (
    <div className="fallGroup">
      <Form
        initialValues={{
          size: componentSize,
          date: ['', ''],
        }}
        onValuesChange={onFormLayoutChange}
        onFinish={handleSubmit}
        size={componentSize}
        form={form}
      >
        <Row>
          <Col span={7} offset={1}>
            <Form.Item label="群聊名称" name="name" className="memberContent">
              <Input placeholder="请输入群聊名称" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="展示状态"
              name="is_visible"
              className="role"
              labelCol={{ span: 5 }}
            >
              <Select
                placeholder="请选择"
                style={{ textAlign: 'left' }}
                getPopupContainer={(e) => e}
              >
                <Select.Option value={1}>显示</Select.Option>
                <Select.Option value={0}>隐藏</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={7} offset={1}>
            <Form.Item
              label="发布时间"
              name="date"
              className="secondHandPostTime"
            >
              <RangePicker />
            </Form.Item>
          </Col>
          <Col span={4} offset={19}>
            <Form.Item>
              <Button onClick={resetSelectors} style={{ marginRight: '20px' }}>
                重置
              </Button>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Col span={3} offset={20}>
          <NewGroup setIsFresh={setIsFresh} />
        </Col>
      </Form>
      <Grouptable ref={memberRef} setIsFresh={setIsFresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: 'right' }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  )
}
export default FallGroup
